var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('AppBar'),_c('NavigationDrawer'),_c('v-main',[_c('v-container',[_c('router-view',{staticStyle:{"min-height":"100%"}})],1),_c('Message')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }